import * as tslib_1 from "tslib";
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import BackButton from '../BackButton';
import SimplePlaceholder from '../SimplePlaceholder';
import wayMarkSvg from './assets/waymark.svg';
import "./NotFoundPlaceholder.css";

var NotFoundPlaceholder =
/** @class */
function (_super) {
  tslib_1.__extends(NotFoundPlaceholder, _super);

  function NotFoundPlaceholder() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NotFoundPlaceholder.prototype.render = function () {
    var _a = this.props,
        title = _a.title,
        text = _a.text,
        renderButtons = _a.renderButtons,
        blockName = _a.blockName,
        className = _a.className;
    return React.createElement("div", {
      className: cx(blockName, className)
    }, React.createElement(SimplePlaceholder, {
      title: title,
      svgImage: wayMarkSvg
    }), React.createElement("p", {
      className: blockName + "__secondary-text"
    }, text), renderButtons());
  };

  NotFoundPlaceholder.propTypes = {
    className: PropTypes.string,
    blockName: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    renderButtons: PropTypes.func
  };
  NotFoundPlaceholder.defaultProps = {
    blockName: 'nx-not-found-placeholder',
    title: 'Page Not Found.',
    text: "Sorry, that page doesn't seem to exist!",
    renderButtons: function renderButtons() {
      return React.createElement(BackButton, null);
    }
  };
  return NotFoundPlaceholder;
}(PureComponent);

export default NotFoundPlaceholder;

try {
  // @ts-ignore
  NotFoundPlaceholder.__docgenInfo = {
    "description": "",
    "displayName": "NotFoundPlaceholder",
    "props": {
      "renderButtons": {
        "defaultValue": null,
        "description": "",
        "name": "renderButtons",
        "required": true,
        "type": {
          "name": "() => ReactNode"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "text": {
        "defaultValue": null,
        "description": "",
        "name": "text",
        "required": false,
        "type": {
          "name": "ReactNode"
        }
      },
      "title": {
        "defaultValue": {
          value: "Page Not Found."
        },
        "description": "",
        "name": "title",
        "required": true,
        "type": {
          "name": "string"
        }
      },
      "svgImage": {
        "defaultValue": null,
        "description": "",
        "name": "svgImage",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "blockName": {
        "defaultValue": {
          value: "nx-not-found-placeholder"
        },
        "description": "",
        "name": "blockName",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}